// Privacy page elements
const Privacy = () => {
	return (
		<>
			<h1>privacy policy</h1>
			<h2>idk we force you to use a cookie, you cant disable it, yea</h2>
		</>
	);
};

// Export
export default Privacy;
